export  default {    
    setSystemSites(state, payload) {
        state.systemSites = payload;
    }
};